import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="portais--page-nav"
//
// Navegacao secundaria (rail) da coluna direita. Coordena os painels
// renderizados em outro lugar do DOM, encontrados por [data-tabs-list-id=<id>],
// alternando o atributo hidden. O estado ativo eh marcado apenas via
// aria-selected — o visual fica por conta das variantes Tailwind aria-selected:.
export default class extends Controller {
  static targets = ["item"]
  static values = { id: String, active: String }

  connect() {
    const names = this.itemTargets.map(item => item.dataset.tabName)
    const initial = names.includes(this.activeValue) ? this.activeValue : this.itemTargets[0]?.dataset.tabName
    if (initial) this.show(initial)
  }

  select(event) {
    this.show(event.currentTarget.dataset.tabName)
  }

  show(name) {
    this.activeValue = name

    this.itemTargets.forEach(item => {
      item.setAttribute("aria-selected", item.dataset.tabName === name)
    })

    this._panels().forEach(panel => {
      panel.classList.toggle("hidden", panel.dataset.tabName !== name)
    })
  }

  _panels() {
    return document.querySelectorAll(`[data-tabs-list-id="${this.idValue}"]`)
  }
}
